import "./_style.less"
import { Card, RadioProps, Space } from "antd";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface PackageCardProps {
  title: string;
  image: string;
  onViewDetail: () => void;
}

const PackageCard: FC<
  PackageCardProps & RadioProps
> = (props) => {
  const { title, image, checked, value, onViewDetail, ...other } = props;
  const { t } = useTranslation();

  return (
    <Card
      className={`package cursor-pointer ${checked ? "package-selected" : ""}`}
      onClick={other.disabled ? undefined : other.onClick}
    >
      <Space
        className="package-wrapper"
        direction="vertical"
        size={20}
      >
        <img
          className="package-image"
          src={image}
          alt={title}
        />

        <div className="package-info">
          <div className="package-title">
            <b style={{ fontSize: 16 }}>{title}</b>
          </div>

          <div
            className="link-text"
            onClick={(e) => {
              e.stopPropagation();
              onViewDetail();
            }}
          >
            <b>{t("common.button.viewDetails")}</b>
          </div>
        </div>
      </Space>
    </Card>
  )
}

export default PackageCard;